import { render, staticRenderFns } from "./DieCare.vue?vue&type=template&id=1eab6533"
import script from "./DieCare.vue?vue&type=script&lang=js"
export * from "./DieCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports